import services from "@/services";
import { useLessonsStore } from "@/stores/lessons";
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Alert, Button } from "@mui/material";
import { useState } from "react";
import { useEffectOnce } from "react-use";
import { DataTable } from "../../../components";
import { useHeaderAdmin } from "../../../hooks";
import ModalRegister from "./modal-register";
import ModalUpdate from "./modal-update";
import { TABLE_COLUMNS } from "./table-columns";
import { TableToolbar } from "./table-toolbar";
import { useData } from "./use-data";

export default function Lessons() {
  const { setAction } = useHeaderAdmin();
  const { isLoading, error, lessons, modules } = useData();
  const { setSelectedItem, selectedItem, clearSelectedItem } =
    useLessonsStore();

  const [isModalRegisterOpen, setIsModalRegisterOpen] =
    useState<boolean>(false);

  const toggleModalRegister = () =>
    setIsModalRegisterOpen(!isModalRegisterOpen);

  const closeModalUpdate = () => {
    clearSelectedItem();
  };

  useEffectOnce(() => {
    setAction(
      <Button onClick={toggleModalRegister}>
        <AddCircleOutlineOutlined />
        <span>Registar</span>
      </Button>
    );
  });

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>;

  return (
    <>
      <ModalUpdate open={selectedItem !== null} onClose={closeModalUpdate} />
      <ModalRegister open={isModalRegisterOpen} onClose={toggleModalRegister} />
      <DataTable
        data={lessons ?? []}
        isLoading={isLoading}
        columns={TABLE_COLUMNS}
        inputProps={{ name: "title" }}
        toolbar={(table) => <TableToolbar table={table} modules={modules} />}
        actions={{
          queryKey: ["/lessons"],
          async onUpdate(data) {
            setSelectedItem(data);
          },
          async onDelete(data) {
            await services.lessons.deleteById(data.id);
          },
        }}
      />
    </>
  );
}
